export default "/images/2d408ca91a064a993351d24f64e7171a.avif";